// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class DocumentDetailService {
   availability: any
   citationTrail: any
   config: any
   dataService: any
   detailConfig: any
   docService: any
   events: any
   fire: any
   scope: any
   urlService: any
   constructor(dataService: any, urlService: any, docService: any, config: any, availability: any, events: any, hooksService: any, citationTrail: any) {
      this.setDocument = this.setDocument.bind(this)
      this.clearDocument = this.clearDocument.bind(this)
      this.dataService = dataService
      this.urlService = urlService
      this.docService = docService
      this.config = config
      this.availability = availability
      this.events = events
      this.citationTrail = citationTrail
      this.scope = {
         doc: {},
         altmetrics_detail_page: this.config.data.altmetrics.altmetrics_detail_page,
         socialSharingServices: this.config.data.socialSharingServices,
         displayCitationTrail: this.config.data.results.displayCitationTrail,
         displayEditor: this.config.data.results.displayEditor
      }

      this.detailConfig = this.config.data.detailPage

      hooksService.setHooks(this, 'DocumentDetailService', ['new'])

      this.dataService.on('update', () => {
         if (this.dataService.data.detailDocument != null) {
            return this.setDocument(this.dataService.data.detailDocument)
         }
         else {}
      })
   }
   // doc doesn't exist so show error?

   setDocument(doc: any) {
      this.scope.doc = doc
      this.scope.display_thumbnail = false
      this.scope.thumbnail_src = doc.thumbnail_large || doc.thumbnail_medium || doc.thumbnail_small
      this.scope.thumbnail_small = doc.thumbnail_small
      this.scope.isAIPage = this.docService.displayAIPage(doc)
      this.scope.isCatalogPage = this.docService.displayDetailPage(doc)
      this.scope.summary = this.docService.getDocumentSummary(doc);
      [this.scope.reservable, this.scope.reserveLink, this.scope.clickTrackLink] = this.docService.getReserveLinkInfo(doc)
      this.scope.requestLink = this.docService.getIllRequestLink(doc)
      this.scope.availabilityDocs = [doc].concat(doc.peer_documents || [])
      this.scope.catalogLink = this.docService.getCatalogLink(this.scope.availabilityDocs)
      this.scope.customMessages = this.detailConfig.messages || []
      this.scope.syndeticsClient = this.detailConfig.syndeticsClient
      // now we know the doc, we can determine if it actually needed to show the trail (this is nice for hiding UI)
      this.scope.displayCitationTrail = this.config.data.results.displayCitationTrail && (this.citationTrail.hasCitedBy(doc) || this.citationTrail.hasCites(doc))
      // create object with sections for quick lookup
      const sections = {};
      // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      (this.detailConfig.sections || []).forEach((section: any) => sections[section] = true)
    
      this.scope.sections = sections
      this.urlService.applyDocumentPath(doc.merged_id)
      const docAvailability = this.availability.getAvailability(doc.availability_id)
      // Metric for results detail
      this.events.publish("actions", "document:detail", {document: doc})
      // no need to get availability if it was already retrieved or if the call errored out
      if (!(docAvailability.availabilities || docAvailability.error)) { this.availability.getSingleDocRTA(doc) }
      return this.fire('new')
   }

   clearDocument() {
      this.scope.doc = {}
      this.urlService.removeDocumentPath()
      // set it back to the config
      return this.scope.displayCitationTrail = this.config.data.results.displayCitationTrail
   }
}

DocumentDetailService.$inject = ['dataService', 'urlService', 'documentService', 'configService', 'availabilityService', 'eventService', 'hooksService', 'citationTrailService']

angular.module('summonApp.services')
   .service('documentDetailService', DocumentDetailService)
